const spinnerTemplate = `<div class='spinner-template'><img src="/img/diamond-gem-small.webp" width="60" alt="${window.translate('alt.spinner')}" title="${window.translate('alt.spinner')}"></div>`;
const spinnerFullPageTemplate = `<div class='js-spinner-fullpage spinner spinner-fullpage'>${spinnerTemplate}</div>`;
const spinnerInContainerTemplate = `<div class='js-spinner spinner spinner-in-container'>${spinnerTemplate}</div>`;

export const enableSpinner = (container) => {
    if (container) {
        if (!container.spinner) {
            container.insertAdjacentHTML('beforeend', spinnerInContainerTemplate);
            container.spinner = container.querySelector('.js-spinner');
        }
    } else {
        document.body.insertAdjacentHTML('beforeend', spinnerFullPageTemplate);
    }
};

export const disableSpinner = (container) => {
    let spinners = [];

    if (container) {
        spinners = container.querySelectorAll('.js-spinner');
        container.spinner = null;
    } else {
        spinners = document.querySelectorAll('.js-spinner-fullpage');
    }

    spinners.forEach((spinner) => {
        spinner.remove();
    });
};
